export default __webpack_public_path__ + "static/media/2272.de3d7523.png";